import { render, staticRenderFns } from "./QuoteDownloadTaxSItuationProof.vue?vue&type=template&id=ed2428a2&"
import script from "./QuoteDownloadTaxSItuationProof.vue?vue&type=script&lang=js&"
export * from "./QuoteDownloadTaxSItuationProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports